<template>
  <div class="userOrganization">
    <el-select
      v-model="value"
      filterable
      :multiple="widget.options.multiple"
      :clearable="widget.options.clearable"
      :placeholder="widget.options.placeholder"
      :style="{ width: widget.options.width }"
      remote
      reserve-keyword
      :disabled="disabled"
      @change="changeValue"
      @focus="showDialog"
    >
      <el-option
        v-for="item in userOrganizationConfig.labelAndValues"
        :key="item.id"
        :value="item.accountName"
        :label="item.name"
      >
      </el-option>
    </el-select>
    <!-- 使用组织机构选择人员弹框组件 -->
    <user-org-dialog
      v-if="widget.type === 'user'"
      :orgDialogVisible.sync="userOrganizationConfig.dialog"
      :multiple="widget.options.multiple"
      :widget="widget"
      :remoteOrganization="remoteOrganization"
      :optionsList="userOrganizationConfig.labelAndValues"
      @sendList="getList"
      :searchGroupData="searchGroupData"
    ></user-org-dialog>
  </div>
</template>

<script>
import UserOrgDialog from './userOrgDialog.vue'
import generateApi from '../../api/generateApi'
import alertUtils from '@/util/alertUtils'
// import { getOrganizationMember } from '@/components/api/userOrgApi.js'
import { getPersonnelSelectionList } from '@/components/api/userOrgApi.js'

export default {
  name: 'user-organization',
  props: ['widget', 'model', 'disabled', 'optionsList'],
  components: {
    UserOrgDialog,
  },
  data() {
    return {
      value: this.model, // value是id数据集合，当单选时，是字符串形式，多选时，是数组形式
      userOrganizationConfig: {
        dialog: false,
        organizationList: [], // 组织机构列表
        labelAndValues: this.optionsList, // 选中数据列表
        newValues: null,
      },
      remoteOrganization: [],
      searchGroupData: [],
    }
  },
  created() {
    this.getRemoteOptions()
  },
  methods: {
    async getFuzzySearch(searchValue) {
      this.searchLoading = true
      const params = {
        // organizationId:
        //   this.remoteOrganization && this.remoteOrganization.length > 0
        //     ? this.remoteOrganization[0].id
        //     : '',
        // pageIndex: 0,
        // pageSize: 50,
        // keyWord: searchValue,
        // fetchSub: true, // 是否查询子组织机构人员
        orgId:
          this.remoteOrganization && this.remoteOrganization.length > 0
            ? this.remoteOrganization[0].id
            : '',
        pageIndex: 0,
        pageSize: 50,
        keyWord: searchValue,
        fetchSub: true, // 是否查询子组织机构人员
        identityTypeIds: this.widget.options.identityTypeIds,
      }
      if (this.widget.options.groupId) {
        params.type = 'group'
        params.groupId = this.widget.options.groupId
      }
      if (this.widget.options.useOraganization) {
        params.type = 'org'
      }
      if (this.widget.options.groupId && this.widget.options.useOraganization) {
        params.type = 'orgAndGroup'
        params.groupId = this.widget.options.groupId
      }

      try {
        // const res = await getOrganizationMember(params)
        const res = await getPersonnelSelectionList(params)
        if (res.flag && res.data && res.data.length > 0) {
          this.userOrganizationConfig.labelAndValues.push({
            ...res.data[0],
            checked: true,
          })
        }
      } catch (error) {
        alertUtils.alertError(error)
      }
    },
    getRemoteOptions() {
      const params = {}
      let url = '/v1/institution/selectInsList'
      if (this.widget.options.orgRootId) {
        params.id = this.widget.options.orgRootId
        url = '/v1/process/getSubAllOrganizations'
      }
      generateApi
        .getCustomService(url, params)
        .then(response => {
          if (response) {
            this.handleOthersService(
              this.widget,
              response,
              this.widget.options.orgRootId
            )
          }
        })
        .catch(() => {
          alertUtils.alertError('组织机构选择' + '接口查询错误', true)
        })
    },
    handleOthersService(widget, obj, useConfigRootId) {
      const data = eval(
        'obj' +
          (widget.options.props.paramFormat
            ? '.' + widget.options.props.paramFormat
            : '')
      )
      const id = widget.options.props.pk
      const pid = widget.options.props.ppk
      const map = {}
      data.forEach(item => {
        if (useConfigRootId) {
          item.ins_name = item.name
          item.pid = item.parentId
          item.ins_code = item.code
        }
        map[item[id]] = item
      })
      data.forEach(item => {
        const parent = map[item[pid]]
        if (parent) {
          ;(parent.children || (parent.children = [])).push(item)
        } else {
          this.remoteOrganization.push(item)
        }
      })

      this.$nextTick(() => {
        if (
          this.model &&
          this.model.length > 0 &&
          this.userOrganizationConfig.labelAndValues.length === 0
        ) {
          this.model.forEach(item => {
            this.getFuzzySearch(item)
          })
        }
      })
    },
    changeValue(val) {
      val = this.value

      this.$emit('update:model', val)
    },
    showDialog() {
      this.userOrganizationConfig.dialog = true
    },
    // 获取选中的数据
    getList(val) {
      this.userOrganizationConfig.labelAndValues = val
      this.$emit('update:optionsList', val)
      if (val.length) {
        if (this.widget.options.multiple) {
          this.userOrganizationConfig.newValues = val.map(item => {
            return item.accountName
          })
          this.value = this.userOrganizationConfig.newValues
        } else {
          this.userOrganizationConfig.newValues = val[0].accountName
          this.value = this.userOrganizationConfig.newValues
        }
      } else {
        if (this.widget.options.multiple) {
          this.value = []
        } else {
          this.value = ''
        }
      }
    },
  },
  watch: {
    value: {
      handler() {},
      immediate: true,
      deep: true,
    },
    model: {
      handler(val) {
        this.value = val
      },
      immediate: true,
      deep: true,
    },
    optionsList: {
      handler(val) {
        this.userOrganizationConfig.labelAndValues = val
        this.userOrganizationConfig.labelAndValues.filter(
          item => (item.checked = true)
        )
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.userOrganization {
  .el-input {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
<style lang="scss">
.el-form-item.is-error {
  .userorgDialog {
    .transfer-body {
      .sw-input.el-input {
        .el-input__inner {
          border-color: #b0b3b7 !important;
        }
      }
    }
  }
}
</style>
